<script setup>
import { format } from "date-fns";

const { intake, isDisabled } = defineProps({
  intake: String | null,
  isDisabled: Boolean,
});

const emit = defineEmits(["onChange"]);

const isEdit = ref(false);
const selectedIntake = ref();

const onUpdateIntake = (value) => {
  console.log(value);
  if (value) emit("onChange", value);
  isEdit.value = false;
};

const cancelEdit = () => {
  setTimeout(() => {
    isEdit.value = false;
  }, 500);
};

onMounted(() => {
  selectedIntake.value = intake;
});
</script>

<template>
  <p v-if="isDisabled" class="text-sm font-normal text-gray-600 py-1">
    {{ intake ? format(intake, "MMM, yyyy") : "Select date" }}
  </p>
  <DatePicker
    v-else-if="isEdit"
    name="intake_date"
    v-model="selectedIntake"
    placeholder="Select date"
    view="month"
    dateFormat="mm/yy"
    class="placeholder:text-xs lg:placeholder:text-sm text-[#4B5563] text-xs lg:text-sm"
    fluid
    @blur="cancelEdit"
    @valueChange="onUpdateIntake"
  />
  <div
    v-else
    class="flex items-center gap-1 cursor-pointer"
    @click="isEdit = true"
  >
    <p class="text-sm font-normal text-gray-600">
      {{ intake ? format(intake, "MMM, yyyy") : "Select date" }}
    </p>

    <div class="flex w-6 h-6 items-center justify-center">
      <i class="pi pi-angle-down" />
    </div>
  </div>
</template>
